//XMLHttpRequest简单封装
// function ajax(json){
// 	var json = json||{};
// 	var type = json.type||"GET";
// 	type = type.toUpperCase();
// 	var url = json.url;
// 	var async = json.async||true;
// 	var data = json.data||"";
// 	var dataArr = [];
// 	for(var key in data){
// 		dataArr.push(key+"="+data[key]);
// 	}
// 	var dataStr = "";
// 	if(dataArr.length>0){
// 		dataStr = dataArr.join("&");
// 	}
// 	var simplePromise = {
// 		successCall:null,
// 		success:function(cb){
// 			simplePromise.successCall=cb;
// 			return simplePromise;
// 		},
// 		errorCall:null,
// 		error:function(cb){
// 			simplePromise.errorCall=cb;
// 			return simplePromise;
// 		},
// 		request:null
// 	};

// 	var request;
// 	try{
// 		request = new XMLHttpRequest();
// 	}catch(e){//兼容todo

// 	}

// 	if(request){
// 		if(type=="GET"){
// 			request.open(type,url+"?"+dataStr,async);
// 			request.withCredentials = true;
// 			request.send(null);
// 		}else{
// 			request.open(type,url+"?mt="+Math.random(),async);
// 			request.withCredentials = true;
// 			request.send(dataStr);
// 		}

// 		request.onreadystatechange=function(){
// 			if(request.readyState==4){
// 				if(request.status==200){
// 					var res = request.responseText;
// 					if(simplePromise.successCall){
// 						simplePromise.successCall(res);
// 					}
// 				}else{
// 					if(simplePromise.errorCall){
// 						simplePromise.errorCall(request)
// 					}
// 				}

// 			}
// 		}
// 	}
// 	simplePromise.request=request;
// 	return simplePromise;
// }

function loadResource(url,cb){
	var index1=url.lastIndexOf(".")+1;  
	var index2=url.length;
	var type = url.substring(index1,index2);
	var newDom = null;
	if(type=="js"){
		newDom = document.createElement("script")
		newDom.setAttribute("type","text/javascript")
		newDom.setAttribute("src", url)
		document.getElementsByTagName("body")[0].appendChild(newDom);
        if (document.all) { //IE
            newDom.onreadystatechange = function() {
                if (newDom.readyState == 'loaded' || newDom.readyState == 'complete') {
                    cb&&cb(newDom)
                }
            }
        } else {
            newDom.onload = function() {
                cb&&cb(newDom)
            }
        }

	}else if(type=="css"){
		newDom = document.createElement("link")
		newDom.setAttribute("rel","stylesheet")
		newDom.setAttribute("type","text/css")
		newDom.setAttribute("href",url)
		document.getElementsByTagName("head")[0].appendChild(newDom)
		cb&&cb()
	}
	return newDom
}

var net = {
	// ajax:ajax,
	loadResource:loadResource
}

module.exports = net;



//////////////////
// WEBPACK FOOTER
// ./src/net.js
// module id = 4
// module chunks = 0